import { Asset } from 'expo-asset';

const onboardingSliderAssets = [
  require('../../assets/onBoarding_desktop_1.png'),
  require('../../assets/onBoarding_desktop_2.png'),
  require('../../assets/onBoarding_desktop_3.png'),
  require('../../assets/onBoarding_desktop_4.png'),
  require('../../assets/onBoarding_mobile_1.png'),
  require('../../assets/onBoarding_mobile_2.png'),
  require('../../assets/onBoarding_mobile_3.png'),
  require('../../assets/onBoarding_mobile_4.png'),
];

const flashMissionPopupAssets = [
  require('../../assets/quick-one-en.png'),
  require('../../assets/quick-one-fr.png'),
  require('../../assets/quick-one-en-desktop.png'),
  require('../../assets/quick-one-fr-desktop.png'),
  require('../../assets/close-button.png'),
];

const missionReferralPopupAssets = [
  require('../../assets/referral-pop-header.png'),
];

const loadedGroups = new Set<string>();
const preloadPromises = new Map<string, Promise<void>>();

const preloadAssetGroup = (key: string, assets: number[]) => {
  const cachedPromise = preloadPromises.get(key);
  if (cachedPromise) {
    return cachedPromise;
  }

  const promise = Asset.loadAsync(assets)
    .catch(() => undefined)
    .then(() => {
      loadedGroups.add(key);
    });

  preloadPromises.set(key, promise);

  return promise;
};

const isAssetGroupReady = (key: string) => loadedGroups.has(key);

export const preloadOnboardingSliderAssets = () => preloadAssetGroup('onboarding-slider', onboardingSliderAssets);
export const preloadFlashMissionPopupAssets = () => preloadAssetGroup('flash-missions-popup', flashMissionPopupAssets);
export const preloadMissionReferralPopupAssets = () => preloadAssetGroup('mission-referral-popup', missionReferralPopupAssets);

export const areOnboardingSliderAssetsReady = () => isAssetGroupReady('onboarding-slider');
export const areFlashMissionPopupAssetsReady = () => isAssetGroupReady('flash-missions-popup');
export const areMissionReferralPopupAssetsReady = () => isAssetGroupReady('mission-referral-popup');

void preloadOnboardingSliderAssets();
void preloadFlashMissionPopupAssets();
void preloadMissionReferralPopupAssets();
